import {
  GET_COUPON_SERVICE,
  GET_COUPON_SERVICE_SUCCESS,
  GET_COUPON_SERVICE_ERROR,
} from './../../actionType.js'

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
}

const GetCouponServices = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUPON_SERVICE:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      }
      break

    case GET_COUPON_SERVICE_SUCCESS:
      state = {
        ...state,
        data: action.payload.results,
        loading: false,
        success: true,
        error: false,
        message: null,
      }
      break

    case GET_COUPON_SERVICE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default GetCouponServices
